import { gql } from "@apollo/client";

export default gql`
  query GetStateFromSuburb($suburb: String!, $postcode: String) {
    getStateFromSuburb(suburb: $suburb, postcode: $postcode) {
      state
    }
  }
`;
